import React from 'react';
import { Icon } from 'kl-b2c-ui-kit';
import { useTranslation } from 'react-i18next';
import {
    CWrap,
    Image,
    Title,
    Link2Item,
    ArrowIcon,
    Go2DetailedBtn,
} from './styled';

export interface NewsListItem {
    imageURL: string;
    title: string;
    link: string;
}

export interface Props {
    data: NewsListItem;
    isFirstInBlock: boolean;
    secondary?: boolean;
    target?: string;
    isAcademy?: boolean;
    index?: number;
}

export const NewsCard: React.FC<Props> = ({
    data: { imageURL, title, link },
    isFirstInBlock,
    secondary,
    target,
    isAcademy,
    index,
}): JSX.Element => {
    const { t } = useTranslation('pages/news');

    return (
        <CWrap
            className={isFirstInBlock ? 'isFirst' : ''}
            isAcademy={isAcademy}
            data-at-selector={'news-item-container'}
            data-index={index}>
            <Link2Item
                className={isFirstInBlock ? 'isFirst' : ''}
                to={link}
                target={target}
                isAcademy={isAcademy}>
                <Image
                    className={isFirstInBlock ? 'isFirst' : ''}
                    data-at-selector={'news-item-image'}>
                    <img src={imageURL} alt={title} />
                </Image>
                <Title
                    className={isFirstInBlock ? 'isFirst' : ''}
                    secondary={secondary}
                    data-at-selector={'news-item-title'}>
                    {title}
                </Title>
                <Go2DetailedBtn
                    isAcademy={isAcademy}
                    data-at-selector={'news-item-go-details'}>
                    {t('moreCaption')}
                    <ArrowIcon>
                        <Icon name={'ArrowRight'} color={'primary'} size={24} />
                    </ArrowIcon>
                </Go2DetailedBtn>
            </Link2Item>
        </CWrap>
    );
};

export default React.memo(NewsCard);
